<!-- <app-academies-header></app-academies-header> -->


<div class="col-md-12 d-flex justify-content-center mb-3 headers-headings mobile-header-div"><a onclick="history.back()"
        class="mobile-header"><i class="bx bx-chevron-left"></i> {{tournamentName}} </a></div>
<p-toast key="toastmsg"></p-toast>

<div class="tabs-bar">
    <ul class="nav nav-tabs">
        <li class="nav-item " style="display: flex; align-items: center;">
            <a class="mobile-header" onclick="history.back()" style="display: flex; align-items: center;">
                <i class="bx bx-chevron-left" style="color: #fff; font-size: 1.6em;"></i> </a>
        </li>
        <li class="nav-item">
            <a class="nav-link " aria-current="page" routerLink="/tournaments/factsheet/{{tournamentId}}"
                [routerLinkActive]="'active'">INFO
            </a>
        </li>
        <li class="nav-item">

            <a [routerLinkActive]="'active'" class="nav-link" routerLink="/tournament-draw-view/{{tournamentId}}"
                [routerLinkActive]="'active'">
                DRAWS</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="/result/{{tournamentId}}">RESULTS </a>
        </li>

    </ul>
</div>
<section class="body-section academies-profile-inner main-section-form draw-section">
    <div class="container">
        <!-- <h1 class="text-center text-capitalize">{{tournamentName}}</h1> -->
        <div class="drawer-box ml-0 mr-0"
            [ngClass]="[totalEntries === 8 ?  'class1' : 'drawer-box' &&  totalEntries === 16 ? 'class2' : 'drawer-box' &&  totalEntries === 32 ? 'class3' : 'drawer-box'  &&  totalEntries === 64 ? 'class4' : 'drawer-box' &&  totalEntries === 128 ? 'class5' : 'drawer-box'  ]">
            <form [formGroup]="drawForm">
                <div class="row text-center categeory-row">

                    <div class="p-field p-col-12 d-flex categeory-selection-div">
                        <div class="media-body draw-heading-div">
                            <h4 class="text-left">{{tournamentName}} </h4>
                            <div class="sub-headings">
                                <!-- <i class="bx bx-map"></i> {{cityname}} | -->
                                <!-- Surface: {{courttype}} -->
                            </div>
                        </div>
                        <!-- <button class="btn btn-primary" (click)="printContent()">
                            <i class='bx bxs-download'></i> Print
                 </button> -->
                        <!-- <div class="dropdown-div">
                            <label for="categoryType">Select Category: </label>
                            <p-dropdown [style]="{'width':'180px'}" inputId="categoryType" [options]="categoryList"
                                formControlName="categoryType" [filter]="true" placeholder="Select Category"
                                optionLabel="matchTypeName"
                                [ngClass]="{ 'is-invalid': submitted && f.categoryType.errors }"
                                (onChange)="onSelectCategory($event)"></p-dropdown>
                            <div *ngIf="submitted && f.categoryType.errors.required" class="invalid-feedback">
                                Please select Match type
                            </div>
                        </div>
                        <div class="dropdown-div">
                            <label for="ageGroup">Select Age Group: </label>
                            <p-dropdown [style]="{'width':'180px'}" inputId="ageGroup" [options]="ageGroupList"
                                formControlName="ageGroup" [filter]="true" placeholder="Select Age Group"
                                optionLabel="ageGroupName" [ngClass]="{ 'is-invalid': submitted && f.ageGroup.errors }"
                                (onChange)="onAgeGroupSelect($event)"></p-dropdown>
                            <div *ngIf="submitted && f.ageGroup.errors.required" class="invalid-feedback">
                                Please select Age Group
                            </div>
                        </div> -->

                        <div class="dropdown-div">
                            <p-dropdown [style]="{'width':'260px'}" inputId="categoryAndAgeGroup"
                                [options]="categoryAndAgeGroupList" formControlName="categoryAndAgeGroup" [filter]="true"
                                placeholder="Select Category" optionLabel="categoryName" [showClear]="true"
                                (onChange)="onselectGetCategoryV2($event)"></p-dropdown>
                            <div *ngIf="submitted && f.categoryAndAgeGroup.errors.required" class="invalid-feedback">
                                Please select MatchType and Age Group
                            </div>
                        </div>

                    </div>

                </div>
                <div *ngIf="totalEntriesArray.length > 0" class="draw-section-parent col-md-12" id="drawPrint">
                    <div class="draw-header col-md-12 draw-main-body p-p-2">
                        <div class="round first-round">
                            First round
                        </div>
                        <div *ngIf="totalEntries == 16 || totalEntries == 32 || totalEntries == 64 || totalEntries == 128"
                            class="round first-round">
                            Second round
                        </div>
                        <div *ngIf="totalEntries == 32 || totalEntries == 64 || totalEntries == 128"
                            class="round first-round">
                            Third round
                        </div>
                        <div *ngIf="totalEntries == 128" class="round first-round">
                            Fourth round
                        </div>
                        <div *ngIf="totalEntries == 64 || totalEntries == 128" class="round first-round">
                            Quarter Finals
                        </div>
                        <div class="round first-round">
                            Semi finals
                        </div>
                        <div class="round first-round">
                            Finals
                        </div>
                        <div class="round first-round">
                            Winner
                        </div>
                    </div>
                    <div class="col-md-12 draw-main-body p-p-2">
                        <div class="round first-round">
                            <ul>
                                <li *ngFor="let entry of totalEntriesArray;let i =index" class=" player">
                                    <div class=" player-main">
                                        <div class=" SL-number">
                                            {{i + 1}}
                                        </div>
                                        <div class=" player-details">
                                            <div class="name-score">
                                                <p-dropdown
                                                    [style]="{'width':'180px','background-color' :'#fff', 'border':'none', 'color':'black'}"
                                                    [panelStyleClass]="panel" [dropdownIcon]="'none'"
                                                    class="player-dropdown" formControlName="player{{i+1}}"
                                                    [options]=" playerList" [filter]="true" inputId="playerDropdown"
                                                    optionLabel="name"
                                                    (onChange)="onClickPlayerDropdown($event, (i+1))">
                                                </p-dropdown>
                                            </div>

                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="round second-round">
                            <ul>
                                <li *ngFor="let entry of secondRoundArray" class=" player">

                                    <div class=" player-main">
                                        <div class=" SL-number">
                                            <a style="height: 44px;" data-original-title="" title="">
                                            </a>
                                        </div>
                                        <div class=" player-details">
                                            <div class=" name-score">
                                                <div class="main-scroew">
                                                    <div class="round-winner">
                                                        <!-- <div class="">
                                                        <p [id]="dynamicId">winner_player{{entry.index}}_player{{entry.index + 1}}_round1</p>
                                                        </div> -->
                                                        <p>
                                                            <input class="winner-text" readonly value="TBD"
                                                                id="winner_player{{entry.index}}_player{{entry.index + 1}}_round1">
                                                            <input class="winner-text" readonly type="hidden"
                                                                value="{{entry.index}}"
                                                                id="winner_id_player{{entry.index}}_player{{entry.index + 1}}_round1">
                                                        </p>
                                                        <div class="winner-score"
                                                            id="winner_concede_player{{entry.index}}_player{{entry.index + 1}}_round1"
                                                            style="display: none;">
                                                            <!-- <input class="winner-score" readonly style="display: none;"> -->
                                                        </div>
                                                        <p><input class="winner-score" type="hidden" readonly
                                                                id="player{{entry.index}}_round2">
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="round third-round">
                            <ul>
                                <li *ngFor="let thirdEntry of thirdRoundArray; let i= index" class=" player">
                                    <div class=" player-main">
                                        <div class=" SL-number">
                                            <a style="height: 44px;" data-original-title="" title="">

                                            </a>
                                        </div>
                                        <div class=" player-details">
                                            <div class=" name-score">
                                                <div class="main-scroew">
                                                    <div class="round-winner">
                                                        <p>
                                                            <input class="winner-text" readonly value="TBD"
                                                                id="winner_player{{thirdEntry.index}}_player{{thirdEntry.index + 2}}_round2">
                                                            <input class="winner-text" type="hidden" readonly
                                                                value="TBD"
                                                                id="winner_id_player{{thirdEntry.index}}_player{{thirdEntry.index + 2}}_round2">
                                                        </p>
                                                        <div class="winner-score" class="winner-score" readonly
                                                            style="display: none;"
                                                            id="winner_concede_player{{thirdEntry.index}}_player{{thirdEntry.index + 2}}_round2">
                                                        </div>
                                                        <p><input class="winner-score" type="hidden" readonly
                                                                id="player{{thirdEntry.index}}_round3">
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="round fourth-round">
                            <ul>
                                <li *ngFor="let fourthEntry of fourthRoundArray" class=" player">
                                    <div class=" player-main">
                                        <div class=" SL-number">
                                            <a style="height: 44px;" data-original-title="" title="">

                                            </a>
                                        </div>
                                        <div class=" player-details">
                                            <div class=" name-score">
                                                <div class="main-scroew">
                                                    <div class="round-winner">
                                                        <p>
                                                            <input class="winner-text" readonly value="TBD"
                                                                id="winner_player{{fourthEntry.index}}_player{{fourthEntry.index + 4}}_round3">
                                                            <input class="winner-text" readonly type="hidden"
                                                                value="TBD"
                                                                id="winner_id_player{{fourthEntry.index}}_player{{fourthEntry.index + 4}}_round3">
                                                        </p>
                                                        <div class="winner-score" readonly style="display: none;"
                                                            id="winner_concede_player{{fourthEntry.index}}_player{{fourthEntry.index + 4}}_round3">
                                                        </div>
                                                        <p><input class="winner-score" type="hidden" readonly
                                                                id="player{{fourthEntry.index}}_round4">
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div *ngIf="totalEntries == 16 || totalEntries == 32 || totalEntries == 64 || totalEntries ==  128"
                            class="round fifth-round">
                            <ul>
                                <li *ngFor="let fifthEntry of fifthRoundArray" class=" player">
                                    <div class=" player-main">
                                        <div class=" SL-number">
                                            <a style="height: 44px;" data-original-title="" title="">

                                            </a>
                                        </div>
                                        <div class=" player-details">
                                            <div class=" name-score">
                                                <div class="main-scroew">
                                                    <div class="round-winner">
                                                        <p>
                                                            <input class="winner-text" readonly value="TBD"
                                                                id="winner_player{{fifthEntry.index}}_player{{fifthEntry.index + 8}}_round4">
                                                            <input class="winner-text" readonly type="hidden"
                                                                value="TBD"
                                                                id="winner_id_player{{fifthEntry.index}}_player{{fifthEntry.index + 8}}_round4">
                                                        </p>
                                                        <div class="winner-score"
                                                            id="winner_concede_player{{fifthEntry.index}}_player{{fifthEntry.index + 8}}_round4"
                                                            style="display: none;">
                                                            <!-- <input class="winner-score" readonly style="display: none;"
                                                          > -->
                                                        </div>
                                                        <p><input class="winner-score" type="hidden" readonly
                                                                id="player{{fifthEntry.index}}_round5">
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div *ngIf="totalEntries == 32 || totalEntries == 64 || totalEntries ==  128"
                            class=" round sixth-round">
                            <ul>
                                <li *ngFor="let sixthEntry of sixthRoundArray" class=" player">
                                    <div class=" player-main">
                                        <div class=" SL-number">

                                        </div>
                                        <div class=" player-details">
                                            <div class=" name-score">
                                                <div class="main-scroew">
                                                    <div class="round-winner">
                                                        <p>
                                                            <input class="winner-text" readonly value="TBD"
                                                                id="winner_player{{sixthEntry.index}}_player{{sixthEntry.index + 16}}_round5">
                                                            <input class="winner-text" readonly type="hidden"
                                                                value="TBD"
                                                                id="winner_id_player{{sixthEntry.index}}_player{{sixthEntry.index + 16}}_round5">
                                                        </p>
                                                        <div class="winner-score"
                                                            id="winner_concede_player{{sixthEntry.index}}_player{{sixthEntry.index + 16}}_round5"
                                                            style="display: none;">
                                                            <!-- <input class="winner-score" readonly style="display: none;"
                                                            > -->
                                                        </div>
                                                        <p><input class="winner-score" type="hidden" readonly
                                                                id="player{{sixthEntry.index}}_round6">
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div *ngIf="totalEntries == 64 || totalEntries ==  128" class="round seven-round">
                            <ul>
                                <li *ngFor="let seventhEntry of seventhRoundArray" class=" player">
                                    <div class=" player-main">
                                        <div class=" SL-number">
                                            <a style="height: 44px;" data-original-title="" title="">

                                            </a>
                                        </div>
                                        <div class=" player-details">
                                            <div class=" name-score">
                                                <div class="main-scroew">
                                                    <div class="round-winner">
                                                        <p>
                                                            <input class="winner-text" readonly value="TBD"
                                                                id="winner_player{{seventhEntry.index}}_player{{seventhEntry.index + 32}}_round6">
                                                            <input class="winner-text" readonly type="hidden"
                                                                value="TBD"
                                                                id="winner_id_player{{seventhEntry.index}}_player{{seventhEntry.index + 32}}_round6">
                                                        </p>
                                                        <div class="winner-score"
                                                            id="winner_concede_player{{seventhEntry.index}}_player{{seventhEntry.index + 32}}_round6"
                                                            style="display: none;">
                                                            <!-- <input class="winner-score" readonly style="display: none;"
                                                            > -->
                                                        </div>
                                                        <p><input class="winner-score" type="hidden" readonly
                                                                id="player{{seventhEntry.index}}_round7">
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div *ngIf="totalEntries == 128" class="round final-round">
                            <ul>
                                <li *ngFor="let eightEntry of eightRoundArray" class=" player">
                                    <div class=" player-main">
                                        <div class=" SL-number">
                                        </div>
                                        <div class=" player-details">
                                            <div class=" name-score">
                                                <div class="main-scroew">
                                                    <div class="round-winner">
                                                        <p>
                                                            <input class="winner-text" readonly value="TBD"
                                                                id="winner_player{{eightEntry.index}}_player{{eightEntry.index + 64}}_round7">
                                                            <input class="winner-text" readonly type="hidden"
                                                                value="TBD"
                                                                id="winner_id_player{{eightEntry.index}}_player{{eightEntry.index + 64}}_round7">
                                                        </p>
                                                        <div class="winner-score"
                                                            id="winner_concede_player{{eightEntry.index}}_player{{eightEntry.index + 64}}_round7"
                                                            style="display: none;">
                                                            <!-- <input class="winner-score" readonly style="display: none;"
                                                                                      > -->
                                                        </div>
                                                        <p><input class="winner-score" type="hidden" readonly
                                                                id="player{{eightEntry.index}}_round8">
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>